import { type DocumentNode, gql } from '@apollo/client';
import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import type { FieldValue } from './types';

interface GetLicenseQueryResult {
  query: {
    license: {
      isValid: FieldValue;
      licenseKey: FieldValue;
    };
  };
}

interface ForceLicenseCheckArgs {
  licenseKey: string;
}

interface ForceLicenseCheckMutationResult {
  mutation: {
    forceLicenseCheck: {
      __args: ForceLicenseCheckArgs;
      license: {
        isValid: FieldValue;
        licenseKey: FieldValue;
      };
    };
  };
}

export const getLicense = (truify: boolean = false): GetLicenseQueryResult => ({
  query: {
    license: {
      isValid: truify,
      licenseKey: truify,
    },
  },
});

export const forceLicenseCheckMutation = (
  truify: boolean = false,
  __args: ForceLicenseCheckArgs,
): ForceLicenseCheckMutationResult => ({
  mutation: {
    forceLicenseCheck: {
      __args,
      license: {
        isValid: truify,
        licenseKey: truify,
      },
    },
  },
});

export const buildLicencseRequestQuery = (): DocumentNode => {
  const q = getLicense(true);
  const gQuery = jsonToGraphQLQuery(q, { pretty: true });
  return gql(gQuery);
};

export const buildForceLicenseMutation = (truify: boolean, licenseKey: string): DocumentNode => {
  const m = forceLicenseCheckMutation(truify, { licenseKey });
  const gMutation = jsonToGraphQLQuery(m, { pretty: true });
  return gql(gMutation);
};
